<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Company Settings" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="settings" pageId="holidays-review" color="white"></help-link>
                    <div v-if="holiday">
                        <v-menu v-if="hasEditAndApproverRights" left v-model="menu_status" offset-y> 
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(holiday.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(holiday.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-tile v-show="hasEditAndApproverRights&&(created_status||forReview_status||rejected_status)" :key="0" @click="dialogDelete=true" title="Delete holiday">
                                    <v-list-tile-title small>Delete</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditAndApproverRights&&(created_status||rejected_status)" :key="1" @click="forReviewHoliday" title="Set holiday to for review">
                                    <v-list-tile-title small>For Review</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditAndApproverRights&&(created_status||rejected_status)" :key="2" @click="showEdit" title="Edit holiday">
                                    <v-list-tile-title small>Edit</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditAndApproverRights&&(forReview_status||rejected_status)" :key="3" @click="approveHoliday" title="Approve holiday">
                                    <v-list-tile-title small>Approve</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditAndApproverRights&&(approved_status||forReview_status)" :key="4" @click="rejectHoliday" title="Reject holiday">
                                    <v-list-tile-title small>Reject</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <v-menu v-if="!hasEditAndApproverRights&&(hasEditRights||hasApproverRights)" left v-model="menu_status" offset-y :disabled="(hasApproverRights&&created_status)||(hasEditRights&&(approved_status||forReview_status))"> 
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(holiday.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(holiday.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-tile v-show="hasEditRights&&(created_status||forReview_status||rejected_status)" :key="0" @click="dialogDelete=true" title="Delete holiday">
                                    <v-list-tile-title small>Delete</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditRights&&(created_status||rejected_status)" :key="1" @click="forReviewHoliday" title="Set holiday to for review">
                                    <v-list-tile-title small>For Review</v-list-tile-title>
                                </v-list-tile>
                                 <v-list-tile v-show="hasEditRights" :key="2" @click="showEdit" title="Edit holiday">
                                    <v-list-tile-title small>Edit</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasApproverRights&&(forReview_status||rejected_status)" :key="3" @click="approveHoliday" title="Approve holiday">
                                    <v-list-tile-title small>Approve</v-list-tile-title>
                                </v-list-tile>
                                 <v-list-tile v-show="hasApproverRights&&(approved_status||forReview_status)" :key="4" @click="rejectHoliday" title="Reject holiday">
                                    <v-list-tile-title small>Reject</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" class="mt-0"></v-progress-linear>
            </v-card>
            
            <v-alert v-if="error" :value="true" color="error" icon="error" dismissible outline class="mt-8">
                {{ errorMessage }}
            </v-alert> 
            <v-alert v-if="!loading&&!approved_status" :value="true" color="warning" icon="warning" dismissible outline class="mt-8">
                Only approved holidays will be included in payroll calculations.
            </v-alert> 

            <v-card v-if="!loading" class="elavation-1 mt-5 mb-5">
                <v-toolbar flat height="35px" class="font-weight-bold primary--text">
                    HOLIDAY DETAILS
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-layout row wrap> 
                    <v-flex xs12 sm6>
                        <v-layout row wrap :style="isMobile? 'padding:10px 20px 0px 20px;' : 'padding:10px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Holiday Name:
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{holiday.description}}
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Holiday Type :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{holiday.holidayTypeName}}
                            </v-flex>  
                        </v-layout>   
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Holiday Date : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{holiday.date|moment('MMMM D, YYYY (dddd)')}}
                            </v-flex>  
                        </v-layout>                     
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-layout row wrap :style="isMobile? 'padding:10px 20px 0px 20px;' : 'padding:10px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Created On : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{holiday.created.createdOn|moment('MMMM D, YYYY h:m a')}}
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Created By : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <span v-if="holiday.created.userId==0">System</span>
                                <span v-else>{{holiday.created.firstName}} {{holiday.created.lastName}}</span>
                            </v-flex>  
                        </v-layout> 
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 10px 20px;' : 'padding:0px 20px 10px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Remarks
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{holiday.remarks}}
                            </v-flex>  
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <!-- replace this with the BasicPopups/Delete component -->
        <v-dialog v-model="dialogDelete" width="500">
            <v-card class="elavation-1" style="border-radius:4px;"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">Confirm Delete</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="text-xs-center">
                    <p>Delete this Holiday?</p>
                    <p>Note: you will not be able to undo this operation.</p>
                </v-card-text>
                 <v-divider></v-divider>
                 <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn title="Delete" class="red" dark @click="deleteHoliday" :loading="loading">Delete</v-btn>
                    <v-btn title="Cancel" @click="dialogDelete=false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAddEdit" persistent width="600">
            <addedit-holiday ref="addEditHolidayRef" :dialogAddEdit.sync="dialogAddEdit" @send="getHoliday(false)"></addedit-holiday>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>
<script>

import holidaysApi from '@/api/holidays'
import commonfn from '@/common/functions'   //for refactor
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import { hasEditRights, hasApproverRights } from '@/helpers/access-permissions'

export default { 
    name: 'Holidays',
    metaInfo: {
        title: 'Holidays',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View and create holdays, so that all users can view in Team Calendar' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },    
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'addedit-holiday' : () => import('@/components/Holidays/AddEditHoliday'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        return {
            commonfn,
            error: false,
            errorMessage: '',
            message: null,
            loading: false,
            loading_status: false,
            dialogDelete: false,
            menu_status: false,
            messages: null,
            dialogAddEdit: false,
            dialogNew: false,
            deleteLoading: false,
            fiscal_period: {},
            holiday: null
        }
    },
    methods: {   
        async forReviewHoliday() {
            try {
                this.loading_status = true
                const response = await holidaysApi.forReview(this.holidayId) 
                if (response && response.status==200) {
                    await this.getHoliday(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approveHoliday() {
            try {
                this.loading_status = true
                const response = await holidaysApi.approve(this.holidayId) 
                if (response && response.status==200) {
                    await this.getHoliday(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async rejectHoliday() {
            try {
                this.loading_status = true
                const response = await holidaysApi.reject(this.holidayId)
                if (response && response.status==200) {
                    await this.getHoliday(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showEdit() {
            this.$refs.addEditHolidayRef.setParamsEdit(this.holiday, this.fiscal_period)
            this.dialogAddEdit = true
        },
        async deleteHoliday() {
            try{
                this.loading = true
                var data = {
                    holidayId: this.holidayId
                }
                const response = await holidaysApi.delete(data)
                if (response && response.status == 200) {
                    this.loading = false
                    this.dialogDelete = false
                    this.$router.push(`/settings/holidays/${this.fiscalPeriodId}`)
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getHoliday(show_loading){
            try{
                this.loading = show_loading
                const response = await holidaysApi.get(this.holidayId)
                if (response && response.status == 200) {
                    this.holiday = response.data.item
                    
                    this.fiscal_period = response.data.fiscalPeriods.filter(x => {
                        return x.fiscalPeriodId == this.fiscalPeriodId
                    })[0]
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getHoliday(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        await this.getHoliday(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `Holidays ${this.fiscal_period.fiscalYear}`
        })
    },
    computed: {
        pageQueryId() {
            return `holiday${this.fiscalPeriodId}${this.holidayId}`
        },
        hasEditAndApproverRights() {
            return this.hasEditRights && this.hasApproverRights
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return hasApproverRights(this.$router.currentRoute.path)
        },
        holidayId() {
            return this.$route.params.holidayId
        },
        fiscalPeriodId() {
            return this.$route.params.fiscalPeriodId
        },
        commentsData() {
            if (this.holiday) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.holidays,
                    notificationTypeId: notificationTypes.holiday_details
                }
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
        created_status() {
            if (this.holiday) return this.holiday.status == commonfn.getStatusCode('Created')
        },
        forReview_status() {
            if (this.holiday) return this.holiday.status == commonfn.getStatusCode('For Review')
        },
        approved_status() {
            if (this.holiday) return this.holiday.status == commonfn.getStatusCode('Approved')
        },
        rejected_status() {
            if (this.holiday) return this.holiday.status == commonfn.getStatusCode('Rejected')
        },
    }
  }
</script>